import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { Button } from "@mui/material";

interface Props {
  selectedIds: string[];
  onDeleteTemplates: (ids: string[]) => void;
}

const WorkbookTemplatesToolbarActions = ({ selectedIds, onDeleteTemplates }: Props) => (
  <Button
    color="error"
    variant="text"
    startIcon={<DeleteOutlineRoundedIcon />}
    onClick={() => onDeleteTemplates(selectedIds)}
  >
    Delete
  </Button>
);

export default WorkbookTemplatesToolbarActions;
